<template>
  <div class="topup">
    <div class="page-header">
      <i class="back-icon" @click="$router.go(-1)"></i>
      <span>Top-Up</span>
    </div>
    <div class="balance">
      <div class="balance-info">
        <span class="title">My Balance</span>
        <span class="num">{{ userInfo.coin }}</span>
      </div>
      <div class="wallet" @click="$router.push('/wallet')">My Wallet</div>
    </div>
    <div class="ads-box">
      <img class="ads" src="@/assets/images/bg/topup-banner.png" alt="" @click="$router.push('/premium')"/>
      <div class="ads-price" v-if="Object.keys(vip).length">{{ vip.currency_symbol || '' }}{{ vip.discount_amount ? priceTransfer(vip.discount_amount) : priceTransfer(vip.price) }}/{{ effectivedayList[vip.effective_days | 0] }} </div>
    </div>
    <div class="content">
      <div class="product">
        <div :class="['item', {'active': activeIdx === index}]" v-for="(item, index) in productList" :key="item.id" @click="activeIdx = index">
          <div class="info">
            <div class="coin">{{ item.coin }}</div>
            <div><span class="tip">Giveaway</span>+{{ item.present }}</div>
          </div>
          <div class="price">${{ priceTransfer(item.price) }}</div>
        </div>
      </div>
    </div>
    <div class="btn" v-if="productList.length" @click="handleBuy">Recharge</div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { getProducts, getVip } from '@/api';
import { priceTransfer } from '@/utils';

export default {
  created() {
    this.init();
  },
  computed: {
    ...mapState(['userInfo']),
  },
  data() {
    return {
      productList: [],
      vip: {},
      priceTransfer,
      activeIdx: 0,
      effectivedayList: {
        1: 'DAY',
        7: 'WEEK',
        30: '1 MONTH',
        180: '6 MONTHS',
        365: 'YEAR',
      },
    };
  },
  methods: {
    async init() {
      const loading = this.$loading();
      const vip = await getVip();
      this.vip = vip?.data?.[0] || {};
      const res = await getProducts();
      if (res.code !== 0) return;
      this.productList = res?.data || [];
      loading.close();
    },
    handleBuy() {
      const productInfo = this.productList?.[this.activeIdx] || {};
      this.$pay({ ...productInfo, payType: 'coin' });
    },
  },
};
</script>
<style lang="less" scoped>
.topup {
  background: url('~@/assets/images/bg/topup.png') rgba(242, 242, 242, 1) no-repeat top center;
  background-size: 100%;
  height: 100%;
  padding-bottom: 16px;
  display: flex;
  flex-direction: column;
  .page-header {
    display: flex;
    align-items: center;
    color: @black;
    font-size: @fontLarge;
    font-weight: 700;
    height: 44px;
    padding: 0 16px;
    color: #fff;
    .back-icon {
      margin-right: 10px;
      .iconMixin({
        background-image: url('~@/assets/images/icon/back-white.png');
      });
    }
  }
  .balance {
    padding: 14px 32px 16px;
    display: flex;
    color: #fff;
    font-size: @fontMedium;
    justify-content: space-between;
    align-items: flex-end;
    .balance-info {
      display: flex;
      flex-direction: column;
    }
    .title {
      font-size: 19px;
      color: rgba(73, 128, 128, 1);
    }
    .num {
      display: flex;
      align-items: center;
      line-height: 42px;
      font-size: 36px;
      font-weight: 700;
      &::before {
        content: '';
        width: 32px;
        height: 32px;
        background: url(@/assets/images/icon/diamond.png) no-repeat center;
        background-size: 100%;
        margin-right: 8px;
      }
    }
    .wallet {
      font-size: @fontLarge;
      font-weight: 700;
      background: linear-gradient(180deg, #30867D 0%, #0A694B 100%);
      height: 44px;
      line-height: 44px;
      padding: 0 16px;
      border-radius: 49px;
    }
  }
  .ads-box {
    position: relative;
    .ads-price {
      background: rgba(0, 137, 104, 1);
      position: absolute;
      height: 28px;
      line-height: 28px;
      border-radius: 49px;
      padding: 0 16px;
      color: #fff;
      font-weight: 700;
      font-size: 15px;
      bottom: 20px;
      left: 35px;
      display: flex;
      align-items: center;
      &::after {
        content: '';
        width: 24px;
        height: 24px;
        background: url('~@/assets/images/icon/arrow-white.png') no-repeat center;
        background-size: 24px;
        margin-left: auto;
      }
    }
  }
  img.ads {
    margin-bottom: 8px;
    padding: 0 16px;
  }
  .content {
    padding: 0 16px 8px;
    flex: 1;
    overflow-y: scroll;
    .product {
      .item {
        display: flex;
        align-items: center;
        padding: 16px;
        background: #fff;
        border-radius: 12px;
        margin-bottom: 8px;
        border: 1px solid #fff;
        &::before {
          content: '';
          width: 32px;
          height: 32px;
          margin-right: 8px;
          background: url(@/assets/images/icon/diamond.png) no-repeat center;
          background-size: 100%;
        }
        &.active {
          border: 1px solid rgba(14, 180, 147, 1);
          .price {
            color: rgba(0, 174, 139, 1);
          }
        }
        .coin {
          font-size: 24px;
          margin-bottom: 8px;
        }
        .tip {
          background: linear-gradient(180deg, rgba(255, 102, 0, 0.1) 0%, rgba(224, 56, 0, 0.1) 100%);
          padding: 4px 8px;
          border-radius: 99px;
          margin-right: 8px;
          color: rgba(243, 84, 1, 1);
          font-weight: 700;
        }
        .price {
          margin-left: auto;
          font-size: @fontLarge;
          font-weight: 700;
        }
      }
    }
  }
  .btn {
    margin: 8px 16px 0;
    padding: 10px;
    text-align: center;
    background: rgba(59, 220, 188, 1);
    border-radius: 99px;
    color: #fff;
    font-size: @fontLarge;
  }
}
</style>
